import { Injectable ,Injector} from '@angular/core';
import {TAGGING_CONSTANT as taggingConst} from '../../common/constants/tagging-constants';
import { MktContentService } from './mkt-content.service';
import { MppRedesignService } from 'src/app/cards/mpp-redesign/mpp-redesign.service';


@Injectable({
  providedIn: 'root'
})
export class MktTaggingTransformationService {
  constructor(
    private _mktContentService: MktContentService
  ){}
  public tagMktCompareCards(val, dynVal) {
    switch (val) {
      case 'home':
        this.triggerPageTagging('nonicms_content', '189aCardHomepageLoad', { dynamicContent: dynVal });
        break;
      case 'home-banner':
        this.triggerEventTagging('nonicms_content', '189bCardHomepageBanner', { dynamicContent: dynVal });
        break;
      case 'view-all-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4aViewAllCreditCards', { dynamicContent: dynVal });
        break;
      case 'cards-prescreened-offers':
        this.triggerPageTagging('nonicms_content', '212_07bCardsPre_ScreenedOffers', { dynamicContent: dynVal });
        break;
      case 'cards-prescreened-offers-ctaclicked':
        this.triggerEventTagging('nonicms_content', '212_07b1CardsPre_ScreenedOffers_CTAClicked', { dynamicContent: dynVal });
        break;
      case 'cards-prescreened-offers-additionalinfo':
        this.triggerPageTagging('nonicms_content', '212_07b4CardsPre_ScreenedOffers_AdditionalInfo', { dynamicContent: dynVal });
        break;
      case 'cards-prescreened-offers-pricinginfo':
        this.triggerPageTagging('nonicms_content', '212_07b5CardsPre_ScreenedOffers_PricingInfo', { dynamicContent: dynVal });
        break;
        case 'cards-prescreened-offers-newtabselected':
        this.triggerEventTagging('nonicms_content', '212_07b0CardsPre_ScreenedOffers_NewTabSelected', { dynamicContent: dynVal });
        break;
        case 'cards-prescreened-offers-joincostcoclicked':
        this.triggerEventTagging('nonicms_content', '212_07b2CardsPre_ScreenedOffers_JoinCostco', { dynamicContent: dynVal });
        break;
      case 'view-all-credit-cards-banner':
        this.triggerEventTagging('nonicms_content', '196_4a2ViewAllCreditCards', { dynamicContent: dynVal });
        break;
      case 'rewards-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4bRewardsCreditCards', { dynamicContent: dynVal });
        break;
      case 'travel-reward-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4cTravelCreditCards', { dynamicContent: dynVal });
        break;
      case 'balance-transfer-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4dBalanceTransferCreditCards', { dynamicContent: dynVal });
        break;
      case '0-percent-intro-apr-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4eIntroAPRCreditCards', { dynamicContent: dynVal });
        break;
      case 'savings-and-cash-back-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4fCashBackCreditCards', { dynamicContent: dynVal });
        break;
      case 'business-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4gBusinessCreditCards', { dynamicContent: dynVal });
        break;
      case 'no-annual-fee-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4hNoAnnualFeeCreditCards', { dynamicContent: dynVal });
        break;
      case 'no-foreign-transaction-fee-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4iNoForeignTransactionFeeCreditCards', { dynamicContent: dynVal });
        break;
      case 'american-airlines-aadvantage-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4mAAdvantageCreditCards', { dynamicContent: dynVal });
        break;
      case 'thank-you-rewards-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4nThankYouRewardsCreditCards', { dynamicContent: dynVal });
        break;
      case 'mastercard-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4oMastercardCreditCards', { dynamicContent: dynVal });
        break;
      case 'most-popular-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4pMostPopularCreditCards', { dynamicContent: dynVal });
        break;
      case 'view-all-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4a5ViewAllCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'rewards-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4b2RewardsCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'travel-reward-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4c2TravelCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'balance-transfer-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4d2BalanceTransferCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case '0-percent-intro-apr-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4e20PercentIntroAPRCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'savings-and-cash-back-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4f2CashBackCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'business-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4g2BusinessCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'no-annual-fee-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4h2NoAnnualFeeCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'no-foreign-transaction-fee-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4i2NoForeignFeeCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'american-airlines-aadvantage-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4m2AAdvantageCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'thank-you-rewards-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4n2ThankYouRewardsCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'mastercard-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4o2MastercardCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'most-popular-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4p2MostPopularCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'view-all-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4a6ViewAllCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'rewards-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4b3RewardsCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'travel-reward-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4c3TravelCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'balance-transfer-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4d3BalanceTransferCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case '0-percent-intro-apr-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4e30PercentIntroAPRCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'savings-and-cash-back-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4f3CashBackCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'business-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4g3BusinessCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'no-annual-fee-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4h3NoAnnualFeeCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'no-foreign-transaction-fee-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4i3NoForeignFeeCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'american-airlines-aadvantage-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4m3AAdvantageCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'thank-you-rewards-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4n3ThankYouRewardsCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'mastercard-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4o3MastercardCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'most-popular-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4p3MostPopularCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;

      case 'view-all-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4a7ViewAllCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'rewards-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4b4RewardsCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'travel-reward-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4c4TravelCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'balance-transfer-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4d4BalanceTransferCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case '0-percent-intro-apr-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4e40PercentIntroAPRCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'savings-and-cash-back-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4f4CashBackCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'business-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4g4BusinessCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'no-annual-fee-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4h4NoAnnualFeeCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'no-foreign-transaction-fee-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4i4NoForeignFeeCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'american-airlines-aadvantage-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4m4AAdvantageCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'thank-you-rewards-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4n4ThankYouRewardsCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'mastercard-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4o4MastercardCreditCards_Reviews', { dynamicContent: dynVal });
        break;
      case 'most-popular-credit-cards-ReviewClicked':
        this.triggerPageTagging('nonicms_content', '196_4p4MostPopularCreditCards_Reviews', { dynamicContent: dynVal });
        break;

      case 'view-all-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4a8ViewAllCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'rewards-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4b5RewardsCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'travel-reward-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4c5TravelCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'balance-transfer-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4d5BalanceTransferCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case '0-percent-intro-apr-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4e50PercentIntroAPRCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'savings-and-cash-back-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4f5CashBackCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'business-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4g5BusinessCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'no-annual-fee-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4h5NoAnnualFeeCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'no-foreign-transaction-fee-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4i5NoForeignFeeCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'american-airlines-aadvantage-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4m5AAdvantageCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'thank-you-rewards-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4n5ThankYouRewardsCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'mastercard-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4o5MastercardCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'most-popular-credit-cards-AdditionalInformation':
        this.triggerPageTagging('nonicms_content', '196_4p5MostPopularCreditCards_AdditionalInformation', { dynamicContent: dynVal });
        break;

      case 'compare-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4kCompareCardsPage', { dynamicContent: dynVal });
        break;
      case 'compareNowButtonClicked':
        this.triggerEventTagging('nonicms_content', '196_4jCompareNowButtonClicked', { dynamicContent: dynVal });
        break;
      case 'compareCardsPageView':
        this.triggerPageTagging('nonicms_content', '196_4kCompareCardsPage', { dynamicContent: dynVal });
        break;
      case 'pdpPageView':
        this.triggerPageTagging('nonicms_content', '196_4lProductDetailPage', { dynamicContent: dynVal });
        break;
      // case 'ccpageview':
      //   this.triggerPageTagging('nonicms_content', '196_8aCompareCardMPP', { dynamicContent: dynVal });
      //   break;
      case 'ccpageviewRemoveCard':
        this.triggerEventTagging('nonicms_content', '196_8bCompareCardMPP_RemoveCard', { dynamicContent: dynVal });
        break;
      case 'ccpageviewUndo':
        this.triggerEventTagging('nonicms_content', '196_8cCompareCardMPP_Undo', { dynamicContent: dynVal });
        break;
      // case 'ccpageviewReviewOverlay':
      //   this.triggerPageTagging('nonicms_content', '196_8dCompareCardMPP_ReviewOverlay', , { dynamicContent: dynVal });
      //   break;
      // case 'ccpageviewReviewOverlaySort':
      //   this.triggerEventTagging('nonicms_content', '196_8eCompareCardMPP_ReviewOverlay_Sort', , { dynamicContent: dynVal });
      //   break;
      case 'cardAdditionalInfo':
        this.triggerEventTagging('nonicms_content', '196_9aCardsAdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'refer-a-friend-mpp':
        this.triggerPageTagging('nonicms_content', '196_11b_Cards_Refer_A_Friend_MPP', { dynamicContent: dynVal });
        break;
      case 'refer-a-friend-error':
        this.triggerPageTagging('nonicms_content', '196_11c_Cards_Refer_A_Friend_Offer_Expired', { dynamicContent: dynVal });
        break;
      case 'page-not-found':
        this.triggerPageTagging('nonicms_content', '580_1Enable_Oops_PageNotFound_Citicards_com', { dynamicContent: dynVal });
        break;
      case 'ecm-atl-awareness-campaign-landing':
        this.triggerPageTagging('nonicms_content', '568_a_Lending_ECM_ATL_Awareness_Campaign_Landing', { dynamicContent: dynVal });
        break;
      case 'citi-flex-loan-landing':
        this.triggerPageTagging('nonicms_content', '467_a1_Citi_Flex_Loan_Landing', { dynamicContent: dynVal });
        break;
      case 'citi-flex-loan-landing-video-overlay':
        this.triggerPageTagging('nonicms_content', '467_a3_Citi_Flex_Loan_Landing_Video', { dynamicContent: dynVal });
        break;
      case 'citi-flex-loan-landing-faq-show-more':
        this.triggerEventTagging('nonicms_content', '467_a4_Citi_Flex_Loan_Landing_FAQ_Show_More', { dynamicContent: dynVal });
        break;
      case 'citi-flex-loan-landing-expand-all-sections':
        this.triggerEventTagging('nonicms_content', '467_a5_Citi_Flex_Loan_Landing_Expand_All_Sections', { dynamicContent: dynVal });
        break;
      case 'cards-costco-landing':
        this.triggerPageTagging('nonicms_content', '466_a_Cards_Costco_Landing', { dynamicContent: dynVal });
        break;
      case 'cards-costco-cash-rewards-program-terms':
        this.triggerPageTagging('nonicms_content', '466_b_Cards_Costco_Cash_Rewards_Program_Terms', { dynamicContent: dynVal });
        break;
      case 'cards-costco-consumer-card-benefits-guide':
        this.triggerEventTagging('nonicms_content', '466_c_Cards_Costco_Consumer_Card_Benefits_Guide', { dynamicContent: dynVal });
        break;
      case 'cards-costco-business-card-benefits-guide':
        this.triggerEventTagging('nonicms_content', '466_d_Cards_Costco_Business_Card_Benefits_Guide', { dynamicContent: dynVal });
        break;
      case 'cards-dividend-quarterly-offer-landing':
        this.triggerPageTagging('nonicms_content', '498_a_Cards_Dividend_Quarterly_Offer_Landing', { dynamicContent: dynVal });
        break;
      case 'cards-dividend-quarterly-offer-landing-cta-clicked':
        this.triggerEventTagging('nonicms_content', '498_a2_Cards_Dividend_Quarterly_Offer_Landing_CTA_Clicked', { dynamicContent: dynVal });
        break;
      case 'cards-dividend-quarterly-offer-landing-exit-link':
        this.triggerEventTagging('nonicms_content', '498_a3_Cards_Dividend_Quarterly_Offer_Landing_Exit_Link', { dynamicContent: dynVal });
        break;
      case 'Cards-AAdvantageMicrosite-Compare_Card':
        this.triggerPageTagging('nonicms_content', '196_12_a_Cards_AAdvantageMicrosite_Compare_Card', { dynamicContent: dynVal });
        break;
      case 'citi-aa-microsite':
        this.triggerPageTagging('nonicms_content', '196_12_b_Cards_AAdvantageMicrosite_Compare_Card', { dynamicContent: dynVal });
        break;
      case 'citi-costco-credit-card-join-costco-link-clicked':
        this.triggerEventTagging('nonicms_content', '196_4l7CardsProductDetailsPage_CostcoLinkClicked', { dynamicContent: dynVal });
        break;
      case 'pdp-ApplyNowButton':
        this.triggerEventTagging('nonicms_content', '196_4l2CardsProductDetailsPage_ApplyNow', { dynamicContent: dynVal });
        break;
      case 'pdp-AnchorLink':
        this.triggerEventTagging('nonicms_content', '196_4l3CardsProductDetailsPage_AnchorLinkClicked', { dynamicContent: dynVal });
        break;
      case 'pdp-PricingInfoLink':
        this.triggerEventTagging('nonicms_content', '196_4l4CardsProductDetailsPage_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'pdp-AdditionalInfoLink':
        this.triggerEventTagging('nonicms_content', '196_4l5CardsProductDetailsPage_AdditionalInformationModal', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_googlePay':
        this.triggerPageTagging('nonicms_content', '465_1aCards_GooglePay_Landing', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_samsungPay':
        this.triggerPageTagging('nonicms_content', '499_1aCards_SamsungPay_Landing', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_samsungPay_HowToPay':
        this.triggerEventTagging('nonicms_content', '499_1a2_Cards_SamsungPay_HowToPay', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_samsungPay_HowToaddyourCitiCards':
        this.triggerEventTagging('nonicms_content', '499_1a3_Cards_SamsungPay_HowToaddyourCitiCards', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_samsungPay_WheretopaywithSamsungPay':
        this.triggerEventTagging('nonicms_content', '499_1a4_Cards_SamsungPay_WheretopaywithSamsungPay', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_googlePay_HowToPay':
        this.triggerEventTagging('nonicms_content', '465_1a2Cards_GooglePayHowtoPay', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_googlePay_HowToaddyourCitiCards':
        this.triggerEventTagging('nonicms_content', '465_1a3_Cards_GooglePay_HowToAddYourCitiCards', { dynamicContent: dynVal });
        break;
      case 'digitalWallet_googlePay_GooglePayWhereToPay':
        this.triggerEventTagging('nonicms_content', '465_1a4_Cards_GooglePayWhereToPay', { dynamicContent: dynVal });
        break;
      case 'citishop_landing':
        this.triggerPageTagging('nonicms_content', '641_a_citishop_landing', { dynamicContent: dynVal });
        break;
      case 'citishop_landing_ctaclicked':
        this.triggerEventTagging('nonicms_content', '641_a2_citishop_landing_ctaclicked', { dynamicContent: dynVal });
        break;
      case 'citishop_landing_expandall':
        this.triggerEventTagging('nonicms_content', '641_a3_citishop_landing_expandall', { dynamicContent: dynVal });
        break;
      case 'citishop_landing_seeallfaqs':
        this.triggerEventTagging('nonicms_content', '641_a4_citishop_landing_seeallfaqs', { dynamicContent: dynVal });
        break;
      case 'citishop_landing_showfaq':
        this.triggerEventTagging('nonicms_content', '641_a5_citishop_landing_showfaq', { dynamicContent: dynVal });
        break;
      // case 'citishop_landing_article_ctaclicked':
      //   this.triggerEventTagging('nonicms_content', '641_a6_citishop_landing_article_CTAClicked', { dynamicContent: dynVal });
      //   break;
      case 'pdp_call_to_apply':
        this.triggerPageTagging('nonicms_content', '196_4_l6_cards_pdp_call_to_apply', { dynamicContent: dynVal });
        break;
      case 'ccpageview':
        this.triggerPageTagging('nonicms_content', '196_4k_CompareCardsPage', { dynamicContent: dynVal });
        break;
      case 'compareApplyNowLink':
        this.triggerEventTagging('nonicms_content', '196_4_k2_Compare_Cards_ApplyNow', { dynamicContent: dynVal });
        break;
      case 'comparePricingLink':
        this.triggerEventTagging('nonicms_content', '196_4_k3_Compare_Cards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'compareReviews':
        this.triggerPageTagging('nonicms_content', '196_4_k4_Compare_Cards_Reviews', { dynamicContent: dynVal });
        break;
      case 'compareAdditionalInfo':
        this.triggerPageTagging('nonicms_content', '196_4_k5_Compare_Cards_AdditionalInformation', { dynamicContent: dynVal });
        break;
      case 'retail-store-credit-cards':
        this.triggerPageTagging('nonicms_content', '196_4qRetailStoreCreditCards', { dynamicContent: dynVal });
        break;
      case 'retail-store-credit-cards-ApplyNowClicked':
        this.triggerEventTagging('nonicms_content', '196_4q2RetailStoreCreditCards_ApplyNowClicked', { dynamicContent: dynVal });
        break;
      case 'retail-store-credit-cards-InternalLinkClicked':
        this.triggerEventTagging('nonicms_content', '196_4q3RetailStoreCreditCards_InternalLinkClicked', { dynamicContent: dynVal });
        break;
      case 'view-all-credit-cards_bannerClicked':
        this.triggerEventTagging('nonicms_content', '196_4a4ViewAllCreditCards_BannerClicked', { dynamicContent: dynVal });
        break;
      case 'earnings-calculator-interaction':
        this.triggerEventTagging('nonicms_content', '196_4l8CardsProductDetailsPage_EarningsCalculatorInteraction', { dynamicContent: dynVal });
        break;
      case 'citishop_prelogin_instructions_video_interaction':
        this.triggerEventTagging('nonicms_content', '641_c4_citishop_prelogin_instructions_videoInteraction', {dynamicContent: dynVal});
        break;
     case 'citishop_prelogin_instructions_ctaclicked':
        this.triggerEventTagging('nonicms_content', '641_c5_citishop_prelogin_instructions_CTAClicked', {dynamicContent: dynVal});
        break;
     case '641_g_Citi_Shop_Landing_Exit_Speedbump':
        this.triggerPageTagging('nonicms_content', '641_g_Citi_Shop_Landing_Exit_Speedbump', {dynamicContent: dynVal});
        break;
     case '641_g2_Citi_Shop_Exit_Speedbump_Continue':
        this.triggerEventTagging('nonicms_content', '641_g2_Citi_Shop_Exit_Speedbump_Continue', {dynamicContent: dynVal});
        break;
      case 'citishop_prelogin_instructions_ioschrome_ctaclicked':
        this.triggerEventTagging('nonicms_content', '641_b2_CitiShop_PreLogin_Instructions_ioschrome_CTAClicked', { dynamicContent: dynVal });
        break;
      case 'citishop_prelogin_instructions_iosedge_ctaclicked':
        this.triggerEventTagging('nonicms_content', '641_d2_CitiShop_PreLogin_Instructions_iosedge_CTAClicked', { dynamicContent: dynVal });
        break;
      case 'citishop_prelogin_instructions_androidchrome_ctaclicked':
        this.triggerEventTagging('nonicms_content', '641_e2_CitiShop_PreLogin_Instructions_androidchrome_CTAClicked', { dynamicContent: dynVal });
        break;
      case 'citishop_prelogin_instructions_androidedge_ctaclicked':
        this.triggerEventTagging('nonicms_content', '641_f2_CitiShop_PreLogin_Instructions_androidedge_CTAClicked', { dynamicContent: dynVal });
        break;
      case 'exitLink':
        this.triggerEventTagging('nonicms_content', '196_4_l_Cards_PDP', { dynamicContent: dynVal });
        break;
      case 'citi_wayfair_benefit_section_new_tab_selected':
        this.triggerEventTagging('nonicms_content', '196_4_l_Cards_PDP_NewTabSelected', { dynamicContent: dynVal });
        break;
      default:
         console.log('NO TAGGING FOUND !!!');
          break;
      }
  }

  //non-ICMS Page view tagging
  triggerPageTagging(nonIcmsId, staticParam?, options?: { dynamicContent: Object }) {
    try {
      if (window) {
        let taggingDataLayer = (<any>window).taggingDataLayer;
        if (taggingDataLayer) {
          const tagging = this.loadTagging(staticParam)  || taggingConst[staticParam] || {};
          const contentParam = options?.dynamicContent ? {...tagging, ...options.dynamicContent, action_type:'page view' } : { ...tagging, action_type:'page view' };
          console.log(`##${staticParam}:TT:PV:New}`);
          staticParam ? taggingDataLayer.applicationData(nonIcmsId, contentParam) : taggingDataLayer.applicationData(taggingConst[nonIcmsId]);
        }
      }
    }
    catch (e) {
      console.log("Error in Tagging");
    }

  }

  //non-ICMS Event tagging
  triggerEventTagging(nonIcmsId, staticParam?, options?: { dynamicContent: Object }) {
    try {
      if (window) {
        let taggingDataLayer = (<any>window).taggingDataLayer;
        if (taggingDataLayer) {
          const tagging = this.loadTagging(staticParam)  || taggingConst[staticParam];
          const contentParam = options?.dynamicContent ? { ...tagging, ...options.dynamicContent, action_type:'event' } : { ...tagging, action_type:'event' };
          console.log(`##${staticParam}:TT:E:New}`);
          staticParam ? taggingDataLayer.updateEventData(nonIcmsId, contentParam) : taggingDataLayer.updateEventData(taggingConst[nonIcmsId]);
        }
      }
    }
    catch (e) {
      console.log("Error in Tagging");
    }
  }

  loadTagging(taggingID: string){
    const taggingIcmsContent = this._mktContentService.get(
        'Branding',
        'copy',
        'tagging_content',
        undefined
      );
      let tagID  = JSON.parse(taggingIcmsContent?.["Tagging"] || "{}");
      return tagID[taggingID];
  }
}

